<template>
  <div class="elements--desktop">
    <FormContainer>
      <template #title>Coûts de formation</template>
      <template #message>
        <BasicAlert
          v-if="msgInformation"
          alertType="info"
          :alertLabel="msgInformation"
        />
        <BasicAlert
          v-if="msgErreur"
          :alertLabel="msgErreur!"
        />
      </template>
      <template #content>
        <div>
          <div class="cardLayoutWrapper cardLayoutWrapper--no-pointer cardLayoutWrapper--header">
            <template v-if="afficheQuantité">
              <div class="elem elem--span-10"><span>Type frais</span></div>
              <div class="elem elem--span-1"></div>
              <div class="elem elem--span-10"><span>Nature</span></div>
              <div class="elem elem--span-1"></div>
              <div class="elem elem--right elem--span-6"><span>Montant HT</span></div>
              <div class="elem elem--span-1"></div>
              <div class="elem elem--right elem--span-6"><span>Quantité</span></div>
            </template>
            <template v-else>
              <div class="elem elem--span-12"><span>Type frais</span></div>
              <div class="elem elem--span-1"></div>
              <div class="elem elem--span-13"><span>Nature</span></div>
              <div class="elem elem--span-1"></div>
              <div class="elem elem--right elem--span-7"><span>Montant HT</span></div>
            </template>
          </div>
          <div class="listCardDesktopWrapper">
            <template
              v-for="(ligneFrais, i) in lignesFrais"
              :key="i"
            >
              <div
                v-if="ligneFrais.type === 'frais'"
                :class="['cardLayoutWrapper  cardLayoutWrapper--no-pointer']"
              >
                <BasicText
                  v-if="ligneFrais.isFirstOfMode"
                  wrap
                  :class="['elem', afficheQuantité ? 'elem--span-10' : 'elem--span-12']"
                >
                  {{ ligneFrais.fraisTitre }}
                </BasicText>
                <div
                  v-else
                  :class="['elem', afficheQuantité ? 'elem--span-10' : 'elem--span-12']"
                ></div>

                <div class="elem elem--span-1"></div>

                <BasicText
                  wrap
                  :class="['elem', afficheQuantité ? 'elem--span-10' : 'elem--span-13']"
                >
                  {{ getNatureFraisLib(ligneFrais.frais.nature) }}
                  <span
                    v-if="ligneFrais.meta?.montant?.$status === PropertyStatus.Required"
                    class="label-required"
                  >
                    *
                  </span>
                  <BasicHint
                    v-if="ligneFrais.hint"
                    class="label-hint"
                    :hint="ligneFrais.hint"
                  />
                </BasicText>

                <div class="elem elem--span-1"></div>

                <BasicInputNumber
                  :model-value="ligneFrais.frais.montant"
                  input-type="table"
                  @update:model-value="
                    (montant) =>
                      modifieFrais({
                        mode: ligneFrais.frais.mode!,
                        nature: ligneFrais.frais.nature!,
                        valeur: montant,
                        field: 'montant',
                      })
                  "
                  :class="['elem', afficheQuantité ? 'elem--span-6' : 'elem--span-7']"
                  :placeholder="
                    afficheQuantité ? (LibelleTypeMontantFrais[ligneFrais.frais.nature as NatureFrais] ?? '€') : '€'
                  "
                  :decimal="2"
                  separateur
                  deletable
                  :readonly
                  :alertLabel="ligneFrais.meta?.montant?.$messageErreurDirty!"
                  :required="ligneFrais.meta?.montant?.$status === PropertyStatus.Required"
                  text-align="right"
                  :disabled="ligneFrais.meta?.montant?.$status === PropertyStatus.NotPresent"
                />

                <div
                  v-if="afficheQuantité"
                  class="elem elem--span-1"
                ></div>

                <!-- Quantité -->
                <BasicInputNumber
                  v-if="afficheQuantité"
                  :model-value="ligneFrais.frais.quantite"
                  input-type="table"
                  @update:model-value="
                    (quantite) =>
                      modifieFrais({
                        mode: ligneFrais.frais.mode!,
                        nature: ligneFrais.frais.nature!,
                        valeur: quantite,
                        field: 'quantite',
                      })
                  "
                  class="elem elem--span-6"
                  :decimal="0"
                  separateur
                  deletable
                  :placeholder="LibelleTypeQuantiteFrais[ligneFrais.frais.nature as NatureFrais]"
                  :readonly
                  :alertLabel="ligneFrais.meta?.quantite?.$messageErreurDirty!"
                  :required="ligneFrais.meta?.quantite?.$status === PropertyStatus.Required"
                  :disabled="
                    ligneFrais.meta?.montant?.$status === PropertyStatus.NotPresent ||
                    ligneFrais.frais.baseCalcul !== 'Quantite'
                  "
                  text-align="right"
                />
              </div>

              <div
                v-else-if="ligneFrais.type === 'total'"
                class="cardLayoutWrapper cardLayoutWrapper--no-pointer total--row"
              >
                <BasicText
                  weight="bold"
                  class="elem elem--span-36"
                >
                  {{ ligneFrais.totalLabel }}
                </BasicText>
              </div>
            </template>
          </div>
        </div>
      </template>
    </FormContainer>
  </div>
  <div class="elements--mobile">
    <FormContainer
      v-for="(typeData, type) in fraisDataParMode"
      :key="type"
    >
      <template #title>{{ typeData.fraisTitre }}</template>
      <template #content>
        <div class="form__bloc">
          <div
            v-for="(frais, index) in typeData.frais"
            :key="index"
            class="col-18 col-md-36 form__bloc"
            style="margin: 0"
          >
            <BasicText
              weight="bold"
              size="body-m"
              class="col-36"
              wrap
            >
              {{ getNatureFraisLib(frais.nature) }}
            </BasicText>

            <!-- Quantité -->
            <WrapperInputNumber
              v-if="frais.baseCalcul === 'Quantite'"
              :model-value="frais.quantite"
              @update:model-value="
                (quantite) =>
                  modifieFrais({
                    mode: frais.mode!,
                    nature: frais.nature!,
                    valeur: quantite!,
                    field: 'quantite',
                  })
              "
              :label="LibelleTypeQuantiteFrais[frais.nature!] ?? 'Nombre'"
              class="col-14 col-sm-36"
              :placeholder="LibelleTypeQuantiteFrais[frais.nature!] ?? 'Nombre de ...'"
              :decimal="0"
              separateur
              deletable
              :readonly
              :alertLabel="typeData.metaFrais?.at(index)?.quantite?.$messageErreurDirty!"
              :required="typeData.metaFrais?.at(index)?.quantite?.$status === PropertyStatus.Required"
            />

            <!-- Montant -->
            <WrapperInputNumber
              v-if="typeData.metaFrais?.at(index)?.montant?.$status !== PropertyStatus.NotPresent"
              :model-value="frais.montant"
              @update:model-value="
                (montant) =>
                  modifieFrais({
                    mode: frais.mode!,
                    nature: frais.nature!,
                    valeur: montant!,
                    field: 'montant',
                  })
              "
              :hint="typeData?.fraisHelp![frais.nature!]"
              :label="getMontantFraisLib(frais)"
              class="col-14 col-sm-36"
              :placeholder="LABEL_MONTANT_DEMANDE_HT + ' en €'"
              :decimal="2"
              separateur
              deletable
              :readonly
              :alertLabel="typeData.metaFrais?.at(index)?.montant?.$messageErreurDirty!"
              :required="typeData.metaFrais?.at(index)?.montant?.$status === PropertyStatus.Required"
            />

            <WrapperInputNumber
              v-else
              :hint="typeData?.fraisHelp![frais.nature!]"
              :label="getMontantFraisLib(frais)"
              class="col-14 col-sm-36"
              :placeholder="LABEL_MONTANT_DEMANDE_HT + ' en €'"
              disabled
            />
          </div>
        </div>
        <div class="form__bloc">
          <div class="col-18 col-md-36 form__bloc">
            <BasicText
              weight="bold"
              class="col-36"
            >
              Montant Total HT
            </BasicText>

            <BasicInputNumber
              :model-value="montantsTotauxParType[type] ?? 0"
              class="col-14 col-sm-36"
              :decimal="2"
              separateur
              disabled
              label="Montant Total HT"
            />
          </div>
        </div>
      </template>
    </FormContainer>
  </div>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import type { NatureFrais } from '@/features/domaine/types/opco'
  import { FormContainer, LABEL_MONTANT_DEMANDE_HT } from '@/features/interface/demande/shared'
  import type { FraisProps } from './Frais.types'
  import { LibelleTypeMontantFrais, LibelleTypeQuantiteFrais } from './Frais.types'
  import { useFraisFormation } from './useFraisFormation'

  const props = defineProps<FraisProps>()

  const { getNatureFraisLib, lignesFrais, montantsTotauxParType, getMontantFraisLib, afficheQuantité } =
    useFraisFormation(props)
</script>

<style scoped lang="less">
  .total--row {
    background-color: @neutral-100;
    height: 42px;
  }

  .elem--right {
    margin-left: auto;
    margin-right: 10px;
  }

  .label-required {
    color: @danger-600;
    margin-left: 4px;
  }

  .label-hint {
    margin-left: 4px;
  }
</style>
